import { MatDialog as MatDialog } from '@angular/material/dialog';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateHelper } from './../../../../_helpers/translate-helper';
import { FormControl } from '@angular/forms';
import { SharedService } from './../../../../_services/shared.service';
import { AfterViewInit, Component, ElementRef, ComponentRef, Inject, Input, NgZone, OnDestroy, PLATFORM_ID, ViewChild, OnInit } from '@angular/core';
import { MobileMenuService } from '@services/mobile-menu.service';
import { WishlistService } from '@services/wishlist.service';
import { CartService } from '@services/cart.service';
import { fromEvent, merge, Observable, Subject } from 'rxjs';
import { isPlatformBrowser, NgClass, NgIf, NgFor } from '@angular/common';
import { fromMatchMedia } from '@shared/functions/rxjs/fromMatchMedia';
import { count, filter, first, shareReplay, takeUntil } from 'rxjs/operators';
import { DropcartType } from '@app/pages/header/components/dropcart/dropcart.component';
import { OffcanvasCartService } from '@app/_services/offcanvas-cart.service';
import { AuthenticationService, QuotationCartService, UserService } from '@app/_services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '@app/_services/direction.service';
import { NavigationExtras, Router, UrlSerializer, RouterLink } from '@angular/router';
import * as _ from 'lodash';
import { SectorPageService } from '@app/_services/sectorPage.service';
import { SearchComponent } from '../../../../shared/components/search/search.component';
import { CityDialogComponent } from '@app/pages/header/components/city-dialog/city-dialog.component';
import { DropdownDirective } from '@app/shared/directives/dropdown.directive';
import { SiteService } from '@app/_services/site.service';
import { CategoriesHeader } from '../../../../_components/categories-header/categories-header.component';
import { TopbarComponent } from '../../../../_components/topbar/topbar.component';
import { AccountMenuComponent } from '../account-menu/account-menu.component';
import { IndicatorComponent } from '../../../header/components/indicator/indicator.component';
import { DropdownDirective as DropdownDirective_1 } from '../../../../shared/directives/dropdown.directive';
import { IconComponent } from '../../../../shared/components/icon/icon.component';

export type MobileHeaderMode = 'alwaysOnTop' | 'pullToShow';

export type MobileHeaderPosition = 'static' | 'sticky';

export type MobileHeaderVisibility = 'hidden' | 'shown';

@Component({
    selector: 'app-mobile-header',
    templateUrl: './mobile-header.component.html',
    styleUrls: ['./mobile-header.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgClass, IconComponent, RouterLink, SearchComponent, DropdownDirective_1, NgIf, NgFor, IndicatorComponent, AccountMenuComponent, TopbarComponent, CategoriesHeader, TranslateModule]
})
export class MobileHeaderComponent implements OnDestroy, AfterViewInit {

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        public menu: MobileMenuService,
        public cart: CartService,
        public quotationCart: QuotationCartService,
        private offcanvasCart: OffcanvasCartService,
        public zone: NgZone,
        public translateService: TranslateService,
        public direction: DirectionService,
        private authService: AuthenticationService,
        private userService: UserService,
        private sharedService: SharedService,
        private router: Router,
        private urlSerializer: UrlSerializer,
        public translateHelper: TranslateHelper,
        private dialog: MatDialog,
        public siteService: SiteService

    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.sharedService.pageSubject$.subscribe(page => {
            this.page = page;
        });
    }

    @Input() stickyMode: MobileHeaderMode | false = false;

    @ViewChild('element') elementRef: ElementRef;
    @ViewChild('panelElement') panelElementRef: ElementRef;
    @ViewChild('searchDropdown') searchDropdownRef: ComponentRef<SearchComponent>;

    destroy$: Subject<void> = new Subject<void>();

    position: MobileHeaderPosition = 'static';
    visibility: MobileHeaderVisibility = 'hidden';
    dropcartType: DropcartType = 'dropdown';

    stuckFrom = null;
    staticFrom = null;
    scrollPosition = 0;
    scrollDistance = 0;
    page;
    userDetails;
    isBrowser = true;
    selectedZone;

    media: Observable<MediaQueryList>;

    get element(): HTMLDivElement {
        return this.elementRef?.nativeElement;
    }

    get panelElement(): HTMLDivElement {
        return this.panelElementRef?.nativeElement;
    }

    get searchDropdown() {
        return this.searchDropdownRef;
    }



    countries = [];
    currentCountry;

    ngOnInit(): void {

        this.searchDropdown
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });

        this.authService.currentZone.subscribe(zone => {
            if (!this.countries || this.countries.length == 0)
                this.authService.getCountries().subscribe((response) => {
                    if (response?.code == 200) {
                        this.countries = response.data;
                        this.getUserCountry(zone);
                    }
                });
            else
                this.getUserCountry(zone);

        })

    }

    getUserCountry(zone) {
        this.selectedZone = zone;
        let countryId = zone?.country?._id || this.countries[0]?._id
        let userCountry = this.countries.find((country) => country._id == countryId);
        this.currentCountry = userCountry
    }

    changeLangage(lang: string) {
        this.authService.currentUser.pipe(takeUntil(this.destroy$)).subscribe((user: any): any => {
            if (user?.preferances?.language != lang) {
                this.userService.setLanguage({ lang: lang }).subscribe(res => {
                    if (res.code == 200) {

                        this.translateService.setDefaultLang(lang);
                        this.translateService.use(lang);

                        let navigationExtras: NavigationExtras;

                        const tree = this.router.parseUrl(this.router.url);

                        let url: any = this.urlSerializer.parse(this.router.url);

                        let stateUrl = this.router.url.split('/');
                        let commands = [];

                        stateUrl.forEach((segment) => {
                            if (segment == "" || segment == "en" || segment == "ar") return;

                            if (segment.includes('?')) {
                                commands.push(segment.split('?')[0]);
                                if (!_.isEmpty(url.queryParams) || !_.isEmpty(tree.queryParams)) {
                                    //commands.push({queryParams: url.queryParams??tree.queryParams});
                                    navigationExtras = {
                                        queryParams: url.queryParams ?? tree.queryParams
                                    };
                                }

                            } else {
                                commands.push(segment);
                            }

                        });

                        commands.unshift('/'.concat(lang))


                        this.router.navigate(commands, navigationExtras);


                        lang == 'ar' ? this.direction.value = 'rtl' : 'ltr';
                    }

                });
            }
        });


    }


    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngAfterViewInit(): void {
        this.searchDropdown

        if (this.stickyMode && isPlatformBrowser(this.platformId)) {
            this.media = fromMatchMedia('(max-width: 991px)', false).pipe(shareReplay({ bufferSize: 1, refCount: true }));
            this.media.pipe(takeUntil(this.destroy$)).subscribe(media => this.onMediaChange(media));
        }

        this.sharedService.searchDropdownSubject$.next(this.searchDropdown);
    }

    onScroll(): void {
        const scrollCurrentPosition = window.pageYOffset;
        const scrollDelta = scrollCurrentPosition - this.scrollPosition;

        // Resets the distance if the scroll changes direction.
        if ((scrollDelta < 0) !== (this.scrollDistance < 0)) {
            this.scrollDistance = 0;
        }

        const distanceToShow = 10; // in pixels
        const distanceToHide = 25; // in pixels

        this.scrollPosition = scrollCurrentPosition;
        this.scrollDistance += scrollDelta;

        if (this.position === 'static' && scrollCurrentPosition >= this.stuckFrom) {
            this.makeSticky();
        }
        if (this.position === 'sticky' && scrollCurrentPosition <= this.staticFrom) {
            this.makeStatic();
        }

        if (this.position === 'sticky') {
            if (this.scrollDistance <= -distanceToShow && this.visibility === 'hidden') {
                this.show();
            }
            if (this.scrollDistance >= distanceToHide && this.visibility === 'shown') {
                this.hide();
            }
        }
    }

    onMediaChange(media: MediaQueryList): void {
        if (media.matches) {
            if (this.stickyMode === 'alwaysOnTop') {
                this.element.classList.add('mobile-header--stuck');
                this.element.classList.add('mobile-header--shown');

                this.panelElement.style.transition = 'none';
                this.panelElement.getBoundingClientRect(); // force reflow
                this.panelElement.style.transition = '';

                this.zone.run(() => this.position = 'sticky');
                this.zone.run(() => this.visibility = 'shown');
            } else {
                const takeUntil$ = merge(
                    this.media.pipe(filter(x => !x.matches), first()),
                    this.destroy$,
                );

                this.zone.runOutsideAngular(() => {
                    fromEvent(window, 'scroll', { passive: true }).pipe(
                        takeUntil(takeUntil$)
                    ).subscribe(() => this.onScroll());
                });

                this.calcBreakpoints();
                this.onScroll();
            }
        } else {
            this.makeStatic();
        }
    }

    calcBreakpoints(): void {
        if (!this.isBrowser) return;
        const elementRect = this.element.getBoundingClientRect();
        this.staticFrom = elementRect.top + window.pageYOffset;
        this.stuckFrom = elementRect.top + elementRect.height + window.pageYOffset + 100;
    }

    private makeStatic(): void {
        this.element.classList.remove('mobile-header--stuck');
        this.element.classList.remove('mobile-header--shown');

        this.panelElement.style.transition = 'none';
        this.panelElement.getBoundingClientRect(); // force reflow
        this.panelElement.style.transition = '';

        this.zone.run(() => this.position = 'static');
        this.zone.run(() => this.visibility = 'hidden');
    }

    private makeSticky(): void {
        this.element.classList.add('mobile-header--stuck');

        this.panelElement.style.transition = 'none';
        this.panelElement.getBoundingClientRect(); // force reflow
        this.panelElement.style.transition = '';

        this.zone.run(() => this.position = 'sticky');
    }

    private show(): void {
        this.element.classList.add('mobile-header--shown');

        this.zone.run(() => this.visibility = 'shown');
    }

    private hide(): void {
        this.element.classList.remove('mobile-header--shown');

        this.zone.run(() => this.visibility = 'hidden');
    }

    onCartClick(): void {
        if (this.dropcartType === 'offcanvas') {
            this.offcanvasCart.open();
        }
    }

    logout() {
        this.authService.logout().subscribe();
    }

    changeCountry(country, languageDropdown) {
        languageDropdown?.toggle(false)
        this.citiesModal(country);
    }

    citiesModal(country): void {
        this.dialog.open(CityDialogComponent, {
            data: { country: country }
        }).afterClosed().subscribe(response => {
            if (response) {
                this.authService.setUserZone(response);
                this.selectedZone = response;
            }
        }, (error) => {
        });
    }


    loadCountries(languageDropdown: DropdownDirective) {

        languageDropdown.toggle(true)
    }
}
